
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-8351100c!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./comments.vue")
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-8351100c&scoped=true!less-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./comments.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./comments.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-8351100c!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./comments.vue"),
  /* scopeId */
  "data-v-8351100c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/contentManagement/comments.vue
// module id = 1503
// module chunks = 3